import { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";

const screenshots = [
  {
    src: "https://customer-assets.emergentagent.com/job_rep/artifacts/17wdgvuc_WhatsApp%20Image%202026-04-07%20at%204.31.47%20PM.jpeg",
    label: "Dashboard",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_rep/artifacts/5t9df0mg_WhatsApp%20Image%202026-04-07%20at%204.31.47%20PM%20%282%29.jpeg",
    label: "Log Exercises",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_rep/artifacts/mlgp487k_WhatsApp%20Image%202026-04-07%20at%204.31.46%20PM%20%281%29.jpeg",
    label: "Habit Calendar",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_rep/artifacts/bqkbbjix_WhatsApp%20Image%202026-04-07%20at%204.31.47%20PM%20%281%29.jpeg",
    label: "Muscle Groups",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_rep/artifacts/f2gzsz75_WhatsApp%20Image%202026-04-07%20at%204.31.46%20PM.jpeg",
    label: "All Habits",
  },
];

const ScreenshotGallery = () => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollState = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      el.addEventListener("scroll", updateScrollState);
      updateScrollState();
      return () => el.removeEventListener("scroll", updateScrollState);
    }
  }, []);

  const scroll = (dir) => {
    const el = scrollRef.current;
    if (el) el.scrollBy({ left: dir * 300, behavior: "smooth" });
  };

  return (
    <section
      data-testid="screenshot-gallery-section"
      className="bg-white py-20 sm:py-28 lg:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0D0D0D] tracking-tight mb-3">
            Designed to feel natural
          </h2>
          <p className="text-base text-[#666]">Every screen built with focus and simplicity in mind.</p>
        </motion.div>

        {/* Scroll container */}
        <div className="relative">
          {/* Left fade + arrow */}
          {canScrollLeft && (
            <button
              onClick={() => scroll(-1)}
              data-testid="gallery-scroll-left"
              className="hidden sm:flex absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white border border-[#E5E5E5] items-center justify-center shadow-lg hover:bg-[#F5F5F5] transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="#0D0D0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
          )}
          {canScrollRight && (
            <button
              onClick={() => scroll(1)}
              data-testid="gallery-scroll-right"
              className="hidden sm:flex absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white border border-[#E5E5E5] items-center justify-center shadow-lg hover:bg-[#F5F5F5] transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L10 8L6 12" stroke="#0D0D0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
          )}

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {screenshots.map((shot, i) => (
              <motion.div
                key={shot.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="flex-shrink-0 snap-center"
              >
                <div
                  className="relative overflow-hidden"
                  style={{
                    width: "220px",
                    height: "440px",
                    borderRadius: "32px",
                    border: "5px solid #0D0D0D",
                    backgroundColor: "#0a0a0a",
                    boxShadow: "0 20px 50px rgba(0,0,0,0.1)",
                  }}
                >
                  <img
                    src={shot.src}
                    alt={shot.label}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <p className="text-center text-xs text-[#999] font-medium mt-3">{shot.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScreenshotGallery;
